import { render, staticRenderFns } from "./compared.vue?vue&type=template&id=32dc86ec&scoped=true&"
import script from "./compared.vue?vue&type=script&lang=js&"
export * from "./compared.vue?vue&type=script&lang=js&"
import style0 from "./compared.vue?vue&type=style&index=0&id=32dc86ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dc86ec",
  null
  
)

export default component.exports